import { messages as commonMessages } from '../common/messages';
export const getSafe = (fn, defaultValue) => {
  try {
    return fn();
  } catch {
    return defaultValue;
  }
};
export const isEmpty = input => {
  if (input !== 0 && input !== false && !input) {
    return true;
  }
  if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) {
    return true;
  }
  return false;
};
export const isNullOrUndefined = input => {
  return input === null || input === undefined;
};
export const noLeadingOrTrailingSpaces = message => ({
  formatMessage
}) => value => {
  if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) {
    return message !== null && message !== void 0 ? message : formatMessage(commonMessages.nameSpaceValidationError);
  }
};